import React from "react";

import { ReviewWhereToBuyListItem } from "@/mk2/apps/wiki/components/ReviewWhereToBuyListItem";
import { StoreEventParamsOfSourceContent } from "@/mk2/helpers/article_ast/filters";

import styles from "./ReviewWhereToBuyList.mscss";

export interface ManualItem {
    eshopName: string;
    eshopUrl: string;
    price?: string;
    ctaLabel?: string;
}

interface OwnProps {
    title: string;
    manualItems: ManualItem[];
    trackClickWithDetails?: StoreEventParamsOfSourceContent;
}

export const ReviewWhereToBuyList: React.FunctionComponent<OwnProps> = React.memo(
    ({ title, manualItems }) => (
        <div className={styles.ReviewWhereToBuyList}>
            <div className={styles.ReviewWhereToBuyList__heading}>{title}</div>
            <div className={styles.ReviewWhereToBuyList__list}>
                {manualItems.map((manualItem, index) => (
                    <ReviewWhereToBuyListItem
                        key={manualItem.eshopUrl}
                        productUrl={manualItem.eshopUrl}
                        price={manualItem.price?.replace(",", ".")}
                        eshopUrl={manualItem.eshopUrl}
                        eshopName={manualItem.eshopName}
                        isLast={index + 1 === manualItems.length}
                        ctaLabel={manualItem.ctaLabel}
                    />
                ))}
            </div>
        </div>
    ),
);
